import { createPluginSpec } from '#src/plugins/spec/types.js';
export function createAdminCrudColumnWebConfig(config) {
    return config;
}
export function createAdminCrudColumnWebImplementation() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const columns = new Map();
    return {
        registerColumnWebConfig(column) {
            if (columns.has(column.name)) {
                throw new Error(`Admin CRUD column with name ${column.name} is already registered`);
            }
            columns.set(column.name, column);
        },
        getColumnWebConfig(name, builtInColumns = []) {
            const builtInColumn = builtInColumns.find((b) => b.name === name);
            if (builtInColumn) {
                return builtInColumn;
            }
            const column = columns.get(name);
            if (!column) {
                throw new Error(`Unable to find column with name ${name}`);
            }
            return column;
        },
        getColumnWebConfigs(builtInColumns = []) {
            return [...builtInColumns, ...columns.values()];
        },
    };
}
/**
 * Spec for adding config component for plugin
 */
export const adminCrudColumnWebSpec = createPluginSpec('core/admin-crud-column-web', { defaultInitializer: createAdminCrudColumnWebImplementation });
//# sourceMappingURL=admin-crud-column-web-spec.js.map